// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-auth a {
  width: 20rem;
  height: 3rem;
  border-radius: 0.5rem;
  margin: 0rem auto 1rem auto;
}

.icon-wrapper {
    vertical-align: middle;
}

.phone-only {
  display: none;
}

@media (max-width: 899px) {
  .phone-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WelcomeButton/WelcomeButton.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".welcome-auth a {\r\n  width: 20rem;\r\n  height: 3rem;\r\n  border-radius: 0.5rem;\r\n  margin: 0rem auto 1rem auto;\r\n}\r\n\r\n.icon-wrapper {\r\n    vertical-align: middle;\r\n}\r\n\r\n.phone-only {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 899px) {\r\n  .phone-only {\r\n    display: block;\r\n  }\r\n\r\n  .desktop-only {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
